import { render } from "./DefaultPopover.vue?vue&type=template&id=71870aaa&scoped=true&ts=true"
import script from "./DefaultPopover.vue?vue&type=script&lang=ts"
export * from "./DefaultPopover.vue?vue&type=script&lang=ts"

import "./DefaultPopover.vue?vue&type=style&index=0&id=71870aaa&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71870aaa"]])

export default __exports__